var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBsStories = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 25,
  viewBox: "0 0 30 25",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 1.003v4.994A1 1 0 0 0 .993 7h16.014A.99.99 0 0 0 18 5.997V1.003A1 1 0 0 0 17.007 0H.993A.99.99 0 0 0 0 1.003m0 9v4.994A1 1 0 0 0 .998 16h28.004A.993.993 0 0 0 30 14.997v-4.994A1 1 0 0 0 29.002 9H.998A.993.993 0 0 0 0 10.003m12 9v4.994c0 .554.481 1.003 1.059 1.003H28.94c.585 0 1.059-.438 1.059-1.003v-4.994c0-.554-.481-1.003-1.059-1.003H13.06c-.585 0-1.059.438-1.059 1.003"
})));
export default SvgBsStories;